<div class="animate-in-from-left">
  <div class="d-flex align-items-center m-b-20">
    <button class="btn btn-transparent p-0">
      <fa-icon icon="arrow-left" class="circle-icon-btn" (click)="goBack()"></fa-icon>
      <span class="sr-only">{{ "order_detail.back" | translate }}</span>
    </button>
    <span class="">{{ "order_detail.order_history" | translate }}</span>
  </div>
  <fui-heading [text]="order ? ('order_detail.order_number' | translate: { orderName: order.name }) : ('order_detail.loading' | translate)" [level]="1" fontSize="f8"></fui-heading>
  <div class="m-y-30">{{ "order_detail.placed_on" | translate }} {{ order.date | date: "MMMM Do, YYYY [at] hh:mma" }}</div>

  <div class="fui-order-details desktop-only">
    <div class="fui-orders-header">
      <div class="fui-orders-col grow">{{ "order_detail.product" | translate }}</div>
      <div class="fui-orders-col">{{ "order_detail.model_sku" | translate }}</div>
      <div class="fui-orders-col">{{ "order_detail.price" | translate }}</div>
      <div class="fui-orders-col tiny">{{ "order_detail.qty" | translate }}</div>
      <div class="fui-orders-col small">{{ "order_detail.total" | translate }}</div>
    </div>
    @for (item of order.items; track item) {
      <div class="fui-order-item" mode="button" tabindex="0">
        <div class="fui-orders-col grow">
          <div class="d-flex align-items-center">
            @if (item.image?.url) {
              <img [src]="item.image.url" [alt]="item.image.alt || item.title" class="m-r-10" style="width: 50px" />
            }
            <div class="flex-grow-1">
              <div class="bold">{{ item.title }}</div>
              <div class="text-muted">{{ item.variantTitle }}</div>
            </div>
          </div>
        </div>
        <div class="fui-orders-col">{{ item.sku }}</div>
        <div class="fui-orders-col">{{ item.price | currency: order.currency }}</div>
        <div class="fui-orders-col tiny">{{ item.quantity }}</div>
        <div class="fui-orders-col small">{{ item.total | currency: order.currency }}</div>
      </div>
    }
  </div>

  <div class="fui-order-details mobile-only">
    @for (item of order.items; track item) {
      <div>
        <div class="bold m-b-10">{{ "order_detail.product" | translate }}</div>
        <div class="d-flex align-items-center m-b-20">
          @if (item.image?.url) {
            <img [src]="item.image.url" [alt]="item.image.alt || item.title" class="m-r-10" style="width: 50px" />
          }
          <div class="flex-grow-1">
            <div class="bold">{{ item.title }}</div>
            <div class="text-muted">{{ item.variantTitle }}</div>
          </div>
        </div>
        <div class="d-flex justify-content-between m-b-5">
          <div class="bold">{{ "order_detail.price" | translate }}</div>
          <div>{{ item.price | currency: order.currency }}</div>
        </div>
        <div class="d-flex justify-content-between m-b-5">
          <div class="bold">{{ "order_detail.quantity" | translate }}</div>
          <div>{{ item.quantity }}</div>
        </div>
        <div class="d-flex justify-content-between m-b-5">
          <div class="bold">{{ "order_detail.total" | translate }}</div>
          <div>{{ item.total | currency: order.currency }}</div>
        </div>
        <hr class="m-y-20" />
      </div>
    }
  </div>

  <div class="fui-order-summay">
    <div class="d-flex justify-content-between m-b-20">
      <div>{{ "order_detail.subtotal" | translate }}</div>
      <div>{{ order.subtotal | currency: order.currency }}</div>
    </div>
    <div class="d-flex justify-content-between m-b-20">
      <div>{{ "order_detail.shipping" | translate }}</div>
      <div>{{ order.shipping | currency: order.currency }}</div>
    </div>
    <div class="d-flex justify-content-between m-b-20">
      <div>{{ "order_detail.tax" | translate }}</div>
      <div>{{ order.tax | currency: order.currency }}</div>
    </div>
    @if (order.discount > 0) {
    <div class="d-flex justify-content-between m-b-20">
        <div>{{ "order_detail.discount" | translate }}</div>
        <div class="c-green">-{{ order.discount | currency: order.currency }}</div>
      </div>
    }
    <hr class="m-y-20" />
    <div class="d-flex justify-content-between m-b-20 bold">
      <div>{{ "order_detail.total" | translate }}</div>
      <div>{{ order.total | currency: order.currency }}</div>
    </div>
    <hr class="m-y-20" />

    @if (order.billingAddress || order.shippingAddress) {
      <div class="row">
        @if (order.shippingAddress) {
          <div class="col-6">
            <div class="secondary-content-bg p-10 m-b-20">
              <div class="bold">{{ "order_detail.shipping_address" | translate }}</div>
              <div class="m-t-10">
                {{ order.shippingAddress.firstName }} {{ order.shippingAddress.lastName }}
                <br />
                {{ order.shippingAddress.address1 }} {{ order.shippingAddress.address2 }}
                <br />
                {{ order.shippingAddress.city }}, {{ order.shippingAddress.province }} {{ order.shippingAddress.zip }}
                <br />
                {{ order.shippingAddress.country }}
                <br />
                {{ order.shippingAddress.phone }}
              </div>
            </div>
          </div>
        }
        @if (order.billingAddress) {
          <div class="col-6">
            <div class="secondary-content-bg p-10 m-b-20">
              <div class="bold">{{ "order_detail.billing_address" | translate }}</div>
              <div class="m-t-10">
                {{ order.billingAddress.firstName }} {{ order.billingAddress.lastName }}
                <br />
                {{ order.billingAddress.address1 }} {{ order.billingAddress.address2 }}
                <br />
                {{ order.billingAddress.city }}, {{ order.billingAddress.province }} {{ order.billingAddress.zip }}
                <br />
                {{ order.billingAddress.country }}
                <br />
                {{ order.billingAddress.phone }}
              </div>
            </div>
          </div>
        }
      </div>
    }

    @if (order.fulfillments?.length) {
      <div class="row">
        @for (fulfillment of order.fulfillments; track fulfillment) {
          @if (fulfillment.trackingInfo?.length) {
            <div class="col-6">
              <div class="secondary-content-bg p-10">
                @for (tracking of fulfillment.trackingInfo; track tracking) {
                  <div class="m-b-20">
                    <div class="bold">{{ "order_detail.tracking_info" | translate: { company: tracking.company } }}</div>
                    <div class="m-t-10">
                      {{ "order_detail.tracking_number" | translate }}
                      <a href="{{ tracking.url }}" target="_blank">{{ tracking.number }}</a>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
